// import SecondFacilities from "./SecondFacilities";
import SimpleCardGridFacilities from "./SimpleCardGridFacilities";
import HighlightPopCardFacilities from "./HighlightPopCardFacilities";
import InfoDuoBoxFacilities from "./InfoDuoBoxFacilities";
import TrippleStackFacilities from "./TrippleStackFacilities";
import MasonryShowcaseFacilities from "./MasonryShowcaseFacilities";
import CleanGridFacilities from "./CleanGridFacilities";
import TimelineHomeFacilities from "./TimelineHomeFacilities";
import { useSelector } from "react-redux";
import CardSimpleGridFacilities from "./CardSimpleGridFacilities";

function HomeeFacilitiesWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);

  return (
    <>
      {sitedata?.theme_facilities === "card-triple-stack" ? (
        <TrippleStackFacilities />
      ) : sitedata?.theme_facilities === "clean-grid-gallery" ? (
        <CleanGridFacilities />
      ) : sitedata?.theme_facilities === "masonry-showcase" ? (
        <MasonryShowcaseFacilities />
      ) : sitedata?.theme_facilities === "info-box-duo" ? (
        <InfoDuoBoxFacilities />
      )  : sitedata?.theme_facilities === "highlight-pop-cards" ? (
        <HighlightPopCardFacilities />
      ) : sitedata?.theme_facilities === "simple-info-box" ? (
        <CardSimpleGridFacilities />
      ) : sitedata?.theme_facilities === "time-line" ? (
        <TimelineHomeFacilities />
      ) : (
        <SimpleCardGridFacilities />
      )}
      





      {/* <HighlightPopCardFacilities /> */}
      {/* <SecondFacilities/> */}
    </>
  );
}

export default HomeeFacilitiesWrapper;
